// extracted by mini-css-extract-plugin
module.exports = {"root":"ActiveDays_root__18Uhj"};